import CampaignApi from "../../services/api/Campaign";
import { getPath, pushOrUpdate, removeCondition } from "../../utils";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";
import * as Comparators from "../../constants/FeatureToggle/Comparators";
import _ from "lodash-es";

function handleError(err) {
  console.error("error in campaign actions:", err);
}

export const setCampaignList = (payload) => {
  return {
    type: ActionTypes.SET_CAMPAIGN_LIST,
    payload,
  };
};

export const setActiveCampaign = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_CAMPAIGN,
    payload,
  };
};

export const setActiveFilters = (payload) => {
  return {
    type: ActionTypes.SET_ACTIVE_FILTERS_CAMPAIGN,
    payload,
  };
};

export const setCurrentPageCampaign = (payload) => {
  return {
    type: ActionTypes.SET_CURRENT_PAGE_CAMPAIGN,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_CAMPAIGN,
    payload,
  };
};

function formatDateToReadableFormat(isoDate) {
  const date = new Date(isoDate);
  const options = {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true,
  };
  return date.toLocaleDateString("en-US", options);
}

export const getCampaignList =
  (filters = {}, pageRequest = {}) =>
  async (dispatch) => {
    try {
      let campaignPayload = {
        filters: _.cloneDeep(filters),
        pageRequest: pageRequest,
      };
      _.unset(campaignPayload, ["filters", "serviceId"]);
      dispatch(setLoader(true));
      let response = await CampaignApi.getCampaignList(campaignPayload);
      dispatch(setLoader(false));
      if (response) {
        let campaigns = response.campaigns;

        campaigns = campaigns.map((campaign) => {
          const startDate = formatDateToReadableFormat(campaign.start_date);
          const spinEndDate = formatDateToReadableFormat(
            campaign.spin_end_date
          );
          const gameEndDate = formatDateToReadableFormat(
            campaign.game_end_date
          );

          return {
            ...campaign,
            start_date: startDate,
            spin_end_date: spinEndDate,
            game_end_date: gameEndDate,
          };
        });

        response.campaigns = campaigns;

        dispatch(setCampaignList(response));
        if (Object.keys(pageRequest).length > 0) {
          dispatch(setCurrentPageCampaign(getPath(pageRequest, "page", 1)));
        }
        if (Object.keys(filters).length > 0) {
          dispatch(setActiveFilters(filters));
        } else if (Object.keys(filters).length === 0) {
          dispatch(resetState({ state: "activeFilters" }));
        }
      }
    } catch (err) {
      dispatch(setLoader(false));
      dispatch(
        setStatus({
          type: "error",
          message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
        })
      );
      handleError(err);
    }
  };

export const updateCampaign = (data) => async (dispatch) => {
  try {
    let campaignPayload = { ...data };
    dispatch(setLoader(true));
    let response = await CampaignApi.updateCampaign(campaignPayload);
    dispatch(setLoader(false));
    if (response) {
      // dispatch(resetState({state : "activeFeature"}));
      dispatch(
        setStatus({
          type: "success",
          message: SuccessMessages.GENERAL_SUCCESS_MESSAGE,
        })
      );
    }
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
